<template>
  <div
    class="flex justify-between flex-col h-full m-0 flex-1 bg-white dark:bg-slate-900"
  >
    <settings-header
      button-route="new"
      :header-title="contact.name"
      show-back-button
      :back-button-label="$t('CONTACT_PROFILE.BACK_BUTTON')"
      :back-url="backUrl"
      :pipelineContact="pipelineContact"
      :show-new-button="false"
    >
      <thumbnail
        v-if="contact.thumbnail"
        :src="contact.thumbnail"
        :username="contact.name"
        size="32px"
        class="mr-2 rtl:mr-0 rtl:ml-2"
      />
    </settings-header>

    <div v-if="uiFlags.isFetchingItem" class="text-center p-4 text-base h-full">
      <spinner size="" />
      <span>{{ $t('CONTACT_PROFILE.LOADING') }}</span>
    </div>
    <div v-else-if="contact.id" class="overflow-hidden flex-1 min-w-0">
      <div class="flex flex-wrap ml-auto mr-auto max-w-full h-full">
        <!-- <div
          v-show="showContactViewPane"
          class="modal-overlay-v1"
          @click="closeContactInfoPanel"
        ></div> -->
        <!-- <contact-info-panel
          :show-close-button="false"
          :show-avatar="true"
          :contact="contact"
          @conversation-selected="handleConversationSelected"
        /> -->
        <contact-info-panel
          :show-close-button="false"
          :show-avatar="true"
          :contact="contact"
        />
        <div class="sm:w-[50%] md:w-[60%] lg:w-[70%] h-full">
          <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
            <woot-tabs-item
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.name"
              :show-badge="false"
            />
          </woot-tabs>
          <div
            class="bg-slate-25 dark:bg-slate-800 h-[calc(100%-40px)] p-4 overflow-auto"
          >
            <contact-notes
              v-if="selectedTabIndex === 0"
              :contact-id="Number(contactId)"
            />
            <conversation-box
              v-if="showMessageView&&selectedTabIndex === 0&&inboxId"
              :inbox-id="inboxId"
              :is-contact-panel-open="isContactPanelOpen"
              :is-on-expanded-layout="isOnExpandedLayout"
              @contact-panel-toggle="onToggleContactPanel"
            />
            <!-- <empty-state-message
              v-else-if="showMessageView&&selectedTabIndex === 0&&!inboxId"
              :message="conversationMissingMessage"
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactInfoPanel from '../components/ContactInfoPanel.vue';
import ContactNotes from 'dashboard/modules/notes/NotesOnContactPage';
import ConversationBox from '../../../../components/widgets/conversation/ConversationBox.vue';
import SettingsHeader from '../../settings/SettingsHeader.vue';
import Spinner from 'shared/components/Spinner.vue';
import Thumbnail from 'dashboard/components/widgets/Thumbnail';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import wootConstants from 'dashboard/constants/globals';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import EmptyStateMessage from '../../../../components/widgets/conversation/EmptyState/EmptyStateMessage.vue'

export default {
  components: {
    ContactInfoPanel,
    ContactNotes,
    SettingsHeader,
    ConversationBox,
    Spinner,
    Thumbnail,
    EmptyStateMessage
  },
  mixins: [uiSettingsMixin],
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectedTabIndex: 0,
      selectedContactId: '',
      conversationId: null,
      inboxId: null,
      pipelineContact:false,
      conversationMissingMessage: this.$t('CONVERSATION.SELECT_A_CONVERSATION')
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
      currentChat: 'getSelectedChat',
      chatList: 'getAllConversations',
    }),
    tabs() {
      return [
        // {
        //   key: 0,
        //   name: 'Send Messages',
        // },
        {
          key: 0,
          name: this.$t('NOTES.HEADER.TITLE'),
        },
      ];
    },
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.records.length === 0;
      return hasEmptyResults;
    },
    contact() {
      return this.$store.getters['contacts/getContact'](this.contactId);
    },
    backUrl() {
      // return `/app/accounts/${this.$route.params.accountId}/contacts`;
      return this.pipelineContact
    ? `/app/accounts/${this.$route.params.accountId}/pipelines`
    : `/app/accounts/${this.$route.params.accountId}/contacts`;
    },
    showContactViewPane() {
      return this.selectedContactId !== '';
    },
    showMessageView() {
      return this.conversationId ? true : !this.isOnExpandedLayout;
    },
    isContactPanelOpen() {
      if (this.currentChat.id) {
        const { is_contact_sidebar_open: isContactSidebarOpen } =
          this.uiSettings;
        return isContactSidebarOpen;
      }
      return false;
    },
    isOnExpandedLayout() {
      const {
        LAYOUT_TYPES: { CONDENSED },
      } = wootConstants;
      const { conversation_display_type: conversationDisplayType = CONDENSED } =
        this.uiSettings;
      return conversationDisplayType !== CONDENSED;
    },
    showConversationList() {
      return this.isOnExpandedLayout ? !this.conversationId : true;
    },
  },
  watch: {
    conversationId() {
      this.fetchConversationIfUnavailable();
    },
  },
  mounted() {
    this.fetchContactDetails();
    this.pipelineData();


    this.initialize();
    this.$watch('$store.state.route', () => this.initialize());
    this.$watch('chatList.length', () => {
      this.setActiveChat();
    });
    this.defaultConversation();
    this.resetContactPanelState();
    bus.$on('open-conversation',this.handleConversationSelected);
  },
  methods: {
    onConversationLoad() {
      this.fetchConversationIfUnavailable();
    },
    fetchConversationIfUnavailable() {
      if (!this.conversationId) {
        return;
      }
      const chat = this.findConversation();
      console.log("My CHat",[chat]);
      if (!chat) {
        this.$store.dispatch('getConversation', this.conversationId);
      }
      else if(chat)
      {
        this.setActiveChat();
      }
    },
    findConversation() {
      const conversationId = parseInt(this.conversationId, 10);
      const [chat] = this.chatList.filter(c => c.id === conversationId);
      return chat;
    },
    initialize() {
      this.$store.dispatch('setActiveInbox', this.inboxId);
      this.setActiveChat();
    },
    setActiveChat() {
      if (this.conversationId) {
        const selectedConversation = this.findConversation();
        // If conversation doesn't exist or selected conversation is same as the active
        // conversation, don't set active conversation.
        if (
          !selectedConversation ||
          selectedConversation.id === this.currentChat.id
        ) {
          return;
        }
        const { messageId } = this.$route.query;
        this.$store
          .dispatch('setActiveChat', {
            data: selectedConversation,
            after: messageId,
          })
          .then(() => {
            bus.$emit(BUS_EVENTS.SCROLL_TO_MESSAGE, { messageId });
          });
      } else {
        this.$store.dispatch('clearSelectedState');
      }
    },
    defaultConversation(){
      console.log("defaultConversation")
      const { LAYOUT_TYPES } = wootConstants;
      this.updateUISettings({
        conversation_display_type: LAYOUT_TYPES.CONDENSED,
        previously_used_conversation_display_type: LAYOUT_TYPES.CONDENSED,
      });
    },






    onClickTabChange(index) {
      this.selectedTabIndex = index;
    },
    fetchContactDetails() {
      const { contactId: id } = this;
      this.$store.dispatch('contacts/show', { id });
    },
    closeContactInfoPanel() {
      this.selectedContactId = '';
      this.showContactInfoPanelPane = false;
    },
    handleConversationSelected(conversation) {
      console.log('Selected Conversation:', conversation);
      bus.$emit('active-conversation',conversation.id);
      this.conversationId=null;
      this.conversationId=String(conversation.id);
      this.selectedTabIndex=0;
      this.inboxId=conversation.inbox_id;
      console.log("My Inbox",this.inboxId);
      // Handle the selected conversation (store it, open a chat, etc.
    },
    onToggleContactPanel() {
      this.updateUISettings({
        is_contact_sidebar_open: !this.isContactPanelOpen,
      });
    },
    resetContactPanelState() {
      this.updateUISettings({
        is_contact_sidebar_open: false, // Ensure panel is closed on page load or refresh
      });
    },
    pipelineData(){
      this.pipelineContact = this.$route?.query?.pipelineContact === "true";
    }
  },
};
</script>
<style scoped>
.modal-overlay-v1 {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 39;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}
</style>